import { selectUserItemId, useAppSelector } from 'slices/commonSelectors';
import { useResolveSectionChief } from 'hooks/icsWorkAssignmentListAttachment/useSectionChiefInfo';

export type SectionChiefInfo = {
  personItemId: string;
  personName?: string;
  positionName: string;
};

export const useSectionChiefResolver = (targetWorkGroupId:string) => {
  const { data: sectionChiefInfo } = useResolveSectionChief(targetWorkGroupId);
  const currentUserGuid = useAppSelector(selectUserItemId);
  const isCurrentUserSectionChief = sectionChiefInfo?.personItemId
    ? sectionChiefInfo?.personItemId === currentUserGuid
    : false;

  return { isCurrentUserSectionChief, sectionChief: sectionChiefInfo };
};
